import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';


export default class TOGGLE_PAGETOP {
  constructor() {
    gsap.registerPlugin(ScrollTrigger);
    document.addEventListener('DOMContentLoaded', this.init );
  }

  init () {
    ScrollTrigger.create({
      trigger: 'body', // 要素"body"がビューポートに入ったときにアニメーション開始
      start: 'top -=70%', // アニメーション開始位置
      markers: false, // マーカー表示
      onEnter() {
        $('.pagetop__wrap').removeClass('hidden');
      },
      onLeaveBack() {
        $('.pagetop__wrap').addClass('hidden');
      },
    });
  }
}
